const filterKey = [
  { title: "show all", key: "*" },
  { title: "blockchain", key: "blockchain" },
  { title: "contract", key: "smart contract" },
  { title: "p2e games", key: "p2e games" },
  { title: "website", key: "website" },
  { title: "trading bot", key: "bot" },
];

const projectData = [
  {
    type: ["blockchain", "website"],
    role: "Full Stack Web3 AI Engineer",
    skills: ["Python", "AI", "Rust", "Typescript", "React"],
    imgUrl: "imgs/works/xeetai.png",
    summary: "Developed backend and AI features powering the xeet.ai platform, focusing on reliability, scalability, and performance under real-world workloads.",
    siteUrl: "https://xeet.ai",
  },
  {
    type: ["blockchain", "website"],
    role: "Backend Engineer",
    skills: ["RWA", "Go", "AI", "Rust", "Typescript", "Python"],
    imgUrl: "imgs/works/zoomart.png",
    summary: "Designed a staking-based token utility model enabling users to offset warehouse storage fees and convert otherwise negative returns into positive yield through partner integrations.",
    siteUrl: "https://zoomart.io/",
  },
  {
    type: ["blockchain", "smart contract", "p2e games"],
    role: "Game Developer",
    skills: ["Solana", "Go", "Redis", "PostgreSQL", "Prisma", "WebSocket"],
    imgUrl: "imgs/works/slither.png",
    summary: "A fast-paced, skill-based Slither multiplayer game where strategy, speed, and precision decide who becomes the biggest snake on the map.",
    siteUrl: "https://pvplabs.xyz",
  },
  {
    type: ["blockchain", "smart contract"],
    role: "Solana Smart Contract Developer",
    skills: ["Rust", "Anchor", "Solana web3", "Meteora"],
    imgUrl: "imgs/works/something.png",
    summary: "Built a Pump.fun competition bonding curve smart contract to enable fair token launches and price discovery.",
    siteUrl: "https://something.tools",
  },
  {
    type: ["blockchain", "p2e games", "website"],
    role: "Bitcoin Game Developer",
    skills: ["Abstract", "Bitcoin Ordinals", "Next.js", "Typescript", "Redis", "Privy"],
    imgUrl: "imgs/works/dstrct.png",
    summary: "Built a Web3 media platform with integrated game experiences on the Abstract chain, including BTC Ordinals minting",
    siteUrl: "https://dstrct.io",
  },
  {
    type: ["blockchain", "smart contract"],
    role: "Solana Smart Contract Developer",
    skills: ["Rust", "Anchor", "Solana web3", "Meteora"],
    imgUrl: "imgs/works/pump-science.png",
    summary: "Built a Pump.fun competition bonding curve smart contract to enable fair token launches and price discovery.",
    siteUrl: "https://pump.science",
  },
  {
    type: ["blockchain", "bot"],
    role: "Full stack Web3 Developer",
    skills: ["Next.js", "Solana web3", "Raydium", "Meteora", "Telegram Bot"],
    imgUrl: "imgs/works/clickcreate-app.png",
    summary: "Developed a trading tool integrated with Pumpfun, Raydium, and Meteora to provide users with a faster and more convenient trading experience.",
    siteUrl: "https://click-create.vercel.app",
  },
  {
    type: ["blockchain", "bot"],
    role: "Solana Web3 Developer",
    skills: ["Python", "Solana web3", "Raydium", "Telegram Bot", "Volume Bot"],
    imgUrl: "imgs/works/volume-bot.png",
    summary: "This Telegram bot is designed to increase the trading volume of any Solana token that has liquidity pools on Solana, across any DEX. It utilizes the Jupiter service to execute token swaps, and the Jito service for efficient transaction bundling. ",
    siteUrl: "https://t.me/puff_volume_bot",
  },
  {
    type: ["blockchain", "smart contract", "p2e games"],
    role: "Smart Contract Developer",
    skills: ["Smart Contract", "Anchor", "Metaplex Core NFT", "Blinks", "Solana Action", "Firebase"],
    imgUrl: "imgs/works/send-blink.png",
    summary: "FOMO is a NFT minting game where players compete for a grand prize pot which starts with $50,000. Audited by Madshield",
    siteUrl: "https://sendarcade.fun",
  },
  {
    type: ["blockchain", "p2e games", "website"],
    role: "Bitcoin Game Developer",
    skills: ["UTXO", "Rune Etching, Minting", "Recursive Ordinal Inscribe", "Marketplace", "Map Game", "Third-party API"],
    imgUrl: "imgs/works/rune-game.png",
    summary: "Built mining game that users can mining their reward basis on their level related collection's ordinal and rune tokens",
    siteUrl: "https://theruneguardians.com",
  },
  {
    type: ["blockchain", "smart contract"],
    role: "Solana Web3 Developer ",
    skills: ["SPL Token", "Metaplex", "Rust", "SPL Token 2022", "Raydium", "Jupiter"],
    imgUrl: "imgs/works/token-creator.png",
    summary: "Built a token creation tool that allows users to create token, token2022, market liquidity pools(bundle) and interact with Raydium and Jupiter",
    siteUrl: "https://raydium-toolkit.vercel.app",
  },
  {
    type: ["blockchain", "website"],
    role: "Full Stack Developer ",
    skills: ["AI Chatbot", "Bitcoin Tech", "OpenSoul AI", "Next.js"],
    imgUrl: "imgs/works/bozo-chat.png",
    summary: "Built an AI chatbot to provide $Bozo info, memes, BTC runes and ordinal tech to the Official $Bozo community.",
    siteUrl: "https://chat.officialbozo.wtf",
  },
  {
    type: ["smart contract"],
    role: "Smart Contract Developer",
    skills: ["Solana", "Anchor", "Smart Contract", "Bonding curve", "Mathematics"],
    imgUrl: "imgs/works/pump_contract.png",
    summary: "Built a smart contract on the Solana that allows users to create and participate in meme token launches.",
    siteUrl: "https://github.com/asseph/bondingcurve-contract",
  },
  {
    type: ["blockchain", "website"],
    role: "Full stack Bitcoin Developer",
    skills: ["Bitcoin", "Rune", "Ordinal", "Discord", "Xverse", "Unisat"],
    imgUrl: "imgs/works/runeguardian.png",
    summary: "⬆️ The central location where you can monitor📺 and control your Rune Guardians and Rune tokens. Explore the Rune Guardians realm further @RuneGuardians",
    siteUrl: "https://dashboard.theruneguardians.com/",
  },
  {
    type: ["blockchain", "website"],
    role: "Full Stack Bitcoin Developer",
    skills: ["Bitcoin", "Ordinal", "ME API", "Next.js"],
    imgUrl: "imgs/works/orange.png",
    summary: "This is rune indexer platform for @XCpinata orange collection",
    siteUrl: "https://orange.xcpinata.com",
  },
  {
    type: ["blockchain", "p2e games"],
    role: "Full Stack Web3 Developer",
    skills: ["Solana Web3.Js", "Next.js", "Node.js", "Twitter API"],
    imgUrl: "imgs/works/Gaimin.png",
    summary: "This is twitter farming platform for Gaimin project",
    siteUrl: "https://ranked.gaimin.io",
  },
  {
    type: ["blockchain", "smart contract", "website"],
    role: "Smart contract Web3 Developer",
    skills: ["Rust", "Web3.Js", "React.js", "Tailwind", "Solana", "Smart contract"],
    imgUrl: "imgs/works/lootbox.png",
    summary:
      "This project is an innovative gaming project built on the Solana blockchain network.",
    siteUrl: "https://lootboxes.vercel.app",
  },
  {
    type: ["blockchain", "smart contract"],
    role: "Smart contract Developer",
    skills: ["Rust", "Anchor", "Solana", "Web3.JS"],
    imgUrl: "imgs/works/E7L-S.png",
    summary: "E7L-Solana protocol.",
    siteUrl: "https://github.com/asseph/E7L-S-Protocol",
  },
  {
    type: ["blockchain", "smart contract"],
    role: "Smart Contract Developer",
    skills: ["Solana", "Smart contract", "Rust", "Web3.JS", "React.js"],
    imgUrl: "imgs/works/elementals-staking.png",
    summary: "pNFT staking functionality for users to stake their NFT and earn passive $ELMNT.",
    siteUrl: "https://new-staking.elementalsnft.io/",
  },
  {
    type: ["blockchain", "website"],
    role: "Full Stack Developer",
    skills: ["Next.Js", "Web3.Js", "Solana", "Twitter API"],
    imgUrl: "imgs/works/T2E.png",
    summary: "Tweet to Earn Platform. The vision of the project is to allow users to earn $ELMNT token by tweeting once per day for the public and twice for token holders.",
    siteUrl: "https://tweet2earn.xyz",
  },
  {
    type: ["blockchain", "website"],
    role: "Bitcoin ordinal Developer",
    skills: ["PSBT", "UTXO", "Ordinal", "Javascript", "React.js"],
    imgUrl: "imgs/works/280629480-91a07b10-e7bc-4ef5-88d5-9135d76e0f30.png",
    summary:
      "The goal of this platform is to develop a cutting-edge lending and borrowing platform specifically designed for Bitcoin Non-Fungible Tokens (NFTs). The platform will leverage the latest technologies and industry best practices to provide users with a seamless and secure experience.",
    siteUrl: "https://github.com/asseph/BTC-NFT-Lending",
  },

  {
    type: ["blockchain", "DEX"],
    role: "Blockchain Developer",
    skills: ["React.Js", "Node.Js", "Bitcoin", "Swap"],
    imgUrl: "imgs/works/274560409-7d5bf3d5-fb5a-446f-8fab-cdc59602860a.png",
    summary:
      "The DEX platform offers a decentralized and secure way to trade cryptocurrencies while providing users with a range of features that enhance their trading experience.",
    siteUrl: "https://justshift.io",
  },

  {
    type: ["p2e games", "blockchain"],
    role: "Blockchain Game Developer",
    skills: ["Unity", "React.Js", "Node.Js", "Solana", "Rust"],
    imgUrl: "imgs/works/work9.jpg",
    summary:
      "This is one kind of Sol Crash Game(Car Crash). Instead of that, the transparent is Taxi 😜.",
    siteUrl: "https://degentaxi.io",
  },

  {
    type: ["blockchain", "smart contract"],
    role: "Smart contract Developer",
    skills: ["Solana", "Rust", "Web3.js", "React.js", "Node.js"],
    imgUrl: "imgs/works/274552398-4ad9e24f-86a2-4edf-b791-2206e38bcd00.png",
    summary:
      "Successfully audited backend and smart contract. Built a site for locking Hoopas and Banana collection for 1 month, 3 months or 6 months.",
    siteUrl: "https://lock.3pixl.com",
  },

  {
    type: ["blockchain", "p2e games"],
    role: "Blockchain Developer",
    skills: ["Next.Js", "Node.Js", "Web3.Js", "Solana", "Rust"],
    imgUrl: "imgs/works/work10.jpg",
    summary:
      "This is coin-flip game on solana network. Payment is Sol and users can put their amount in this game.",
    siteUrl: "https://coinflip.deezkits.com",
  },
  {
    type: ["blockchain", "website"],
    role: "Frontend and Web3 Developer",
    skills: ["React.Js", "Cardano"],
    imgUrl: "imgs/works/work12.png",
    summary: "Adaki Dashboard on Cardano network.",
    siteUrl: "https://adaki.io",
  },
  {
    type: ["blockchain", "p2e games"],
    role: "Cardano Developer",
    skills: ["React.Js", "Web3.Js", "Cardano"],
    imgUrl: "imgs/works/work11.png",
    summary:
      "Adaki is a web3 brand and NFT platform built on the Cardano Blockchain.",
    siteUrl: "https://dashboard.adaki.io",
  },
  {
    type: ["blockchain", "website"],
    role: "Frontend and Web3 Developer",
    skills: ["Next.Js", "Web3.Js", "Tailwind", "Solana"],
    imgUrl: "imgs/works/work7.png",
    summary:
      "Yaku Hub is your access pass to a smarter platform that delivers value to the ecosystem as a whole.",
    siteUrl: "https://www.yaku.ai",
  },
  {
    type: ["website"],
    role: "Frontend Developer",
    skills: ["Nuxt.Js", "Tailwind"],
    imgUrl: "imgs/works/work8.png",
    summary: "WeDance is online dance event platform.",
    siteUrl: "https://wedance.vip",
  },
  {
    type: ["blockchain", "website"],
    role: "Solana Developer",
    skills: ["Next.Js", "Node.Js", "Rust", "Solana", "Web3.JS"],
    imgUrl: "imgs/works/work5.png",
    summary:
      "This is pair staking platform on Solana network for BASC (Baby Ape Social Club) collection.",
    siteUrl: "https://stakingv2.babyapesocialclub.com",
  },
  {
    type: ["blockchain"],
    role: "Avalanche Developer",
    skills: ["React.Js", "Web3.Js", "Avalanche"],
    imgUrl: "imgs/works/work3.png",
    summary: "This is mint website on Avalanche network.",
    siteUrl: "https://avalanche-nft-mint.vercel.app/#home",
  },
  {
    type: ["app"],
    role: "Mobile Developer",
    skills: ["iOS", "Android"],
    imgUrl: "imgs/works/work2.png",
    summary: "G-Plans is fitness mobile application.",
    siteUrl: "https://g-plans.com",
  },
  {
    type: ["blockchain", "website"],
    role: "Blockchain Developer",
    skills: ["React.Js", "Web3.Js", "Rust", "Solana"],
    imgUrl: "imgs/works/work18.png",
    summary:
      "This is Raffle and Auction platform for TombStoned collection on Solana network.",
    siteUrl: "https://mausoleum.tombstoned.app",
  },
  {
    type: ["website"],
    role: "Web Developer",
    skills: ["Angular", "Node.JS", "Bootstrap"],
    imgUrl: "imgs/works/work4.png",
    summary: "This is Hotel Booking platform for 24 North Hotel.",
    siteUrl: "https://www.24northhotel.com",
  },
  {
    type: ["website"],
    role: "Web Developer",
    skills: ["React.Js", "Bootstrap"],
    imgUrl: "imgs/works/work6.png",
    summary:
      "Oxford Cars leads provider of transport for the people of Oxford and the surrounding area 24/7.",
    siteUrl: "https://oxfordcars.co.uk",
  },
];

export { filterKey, projectData };
